/**
 * @flow
 * @relayHash 75dacccbc122b55c15e40c86077e49b0
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SetV4BetaInput = {|
  userId: string,
  enabled: boolean,
  clientMutationId?: ?string,
|};
export type SetV4BetaMutationVariables = {|
  input: SetV4BetaInput
|};
export type SetV4BetaMutationResponse = {|
  +setV4Beta: ?{|
    +user: ?{|
      +v4BetaEnabled: ?boolean
    |}
  |}
|};
export type SetV4BetaMutation = {|
  variables: SetV4BetaMutationVariables,
  response: SetV4BetaMutationResponse,
|};
*/


/*
mutation SetV4BetaMutation(
  $input: SetV4BetaInput!
) {
  setV4Beta(input: $input) {
    user {
      v4BetaEnabled
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "SetV4BetaInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "v4BetaEnabled",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "SetV4BetaMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "setV4Beta",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "SetV4BetaPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "SetV4BetaMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "setV4Beta",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "SetV4BetaPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "SetV4BetaMutation",
    "id": null,
    "text": "mutation SetV4BetaMutation(\n  $input: SetV4BetaInput!\n) {\n  setV4Beta(input: $input) {\n    user {\n      v4BetaEnabled\n      id\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '83b98a0cc4c086d1da917a9524fa50d9';
module.exports = node;
